var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.32715,
    y: 5.5875,
    width: 12.2925,
    height: 7.82252,
    fill: "#8A92A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6662 2.88627C19.2424 4.01703 19.2424 5.49728 19.2424 8.45778V11.311C19.2424 11.6067 19.2424 11.7545 19.2365 11.8794C19.1076 14.6024 16.9292 16.7808 14.2062 16.9096C14.0814 16.9156 13.9164 16.9156 13.5867 16.9156L13.502 16.9157C12.4234 16.9225 11.3727 17.2593 10.491 17.8806L10.4349 17.9206L7.67478 19.8921C6.72859 20.5678 5.48522 19.5918 5.91707 18.5123C6.22297 17.7475 5.65975 16.9156 4.83607 16.9156H4.19989C1.99766 16.9156 0.212402 15.1303 0.212402 12.928V8.45778C0.212402 5.49728 0.212402 4.01703 0.788554 2.88627C1.29535 1.89162 2.10403 1.08294 3.09867 0.576151C4.22943 0 5.70968 0 8.67018 0H10.7846C13.7452 0 15.2254 0 16.3562 0.576151C17.3508 1.08294 18.1595 1.89162 18.6662 2.88627ZM6.55574 8.45778C6.55574 9.04166 6.0824 9.515 5.49851 9.515C4.91463 9.515 4.44129 9.04166 4.44129 8.45778C4.44129 7.8739 4.91463 7.40056 5.49851 7.40056C6.0824 7.40056 6.55574 7.8739 6.55574 8.45778ZM10.7846 8.45778C10.7846 9.04166 10.3113 9.515 9.7274 9.515C9.14352 9.515 8.67018 9.04166 8.67018 8.45778C8.67018 7.8739 9.14352 7.40056 9.7274 7.40056C10.3113 7.40056 10.7846 7.8739 10.7846 8.45778ZM13.9563 9.515C14.5402 9.515 15.0135 9.04166 15.0135 8.45778C15.0135 7.8739 14.5402 7.40056 13.9563 7.40056C13.3724 7.40056 12.8991 7.8739 12.8991 8.45778C12.8991 9.04166 13.3724 9.515 13.9563 9.515Z",
    fill: "#D0D3DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconchat);
export default __webpack_public_path__ + "static/media/Icon.chat.eafc51e57ae88eeba91872e5526808fd.svg";
export { ForwardRef as ReactComponent };